module.exports = __webpack_public_path__ + "img/main-page-logo.4c2e83b4.svg";